export const workshopsPageLinks = {
  en: undefined,
  ru: {
    title: 'Смотреть все',
    href: '/ru/workshops/',
  },
  de: undefined,
  tr: {
    title: 'Tümünü gör',
    href: '/tr/workshops/',
  },
};

export const eventPageDict = {
  en: {
    event: 'Event',
    location: 'Location',
    pastEvents: 'Past events',
    conferencesAndOtherEvents: 'Conferences & other events',
    weShareKnowledge:
      'We share knowledge and discuss investment immigration trends around the world',
    offlineEvents: 'Offline events',
    workshops: 'Workshops',
    allEvents: 'All events',
  },
  ru: {
    event: 'Событие',
    location: 'Место проведения',
    pastEvents: 'Прошедшие события',
    conferencesAndOtherEvents: 'Конференции и другие мероприятия',
    weShareKnowledge: 'Мы любим делиться знаниями!',
    offlineEvents: 'Офлайн мероприятия',
    workshops: 'Вебинары',
    allEvents: 'Все мероприятия',
  },
};

export const workshopTypesDict = {
  en: {
    workshop: 'Workshop',
    onlineConference: 'Online conference',
  },
  ru: {
    workshop: 'Вебинар',
    onlineConference: 'Онлайн-конференция',
  },
};
